module.exports = __webpack_public_path__ + "img/home_main_image_pc.55d6be80.png";